import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { iconSize, spacing } from "../../../core/design-system/index.js";
import { Text } from "../../ui/components/text.js";
import { Container } from "../components/basic.js";
import { Button } from "../components/buttons.js";
export function WalletTypeRowButton(props) {
    return (_jsx(Button, { fullWidth: true, variant: "outline", style: {
            display: "flex",
            justifyContent: "flex-start",
            padding: spacing.sm,
        }, onClick: () => {
            props.onClick();
        }, disabled: props.disabled, children: _jsxs(Container, { flex: "row", gap: "sm", center: "y", color: "accentText", children: [_jsx(props.icon, { size: iconSize.md }), _jsx(Text, { color: "primaryText", children: props.title })] }) }));
}
//# sourceMappingURL=WalletTypeRowButton.js.map